import { ReactNode } from 'react';
import { Toaster } from 'react-hot-toast';
import { ErrorBoundary } from '@/shared/components/feedback/ErrorBoundary';
import { AuthProvider } from '@/features/auth/providers/AuthProvider';
import { NotificationProvider } from '@/shared/providers/NotificationProvider';
import { AccessibilityProvider } from '@/shared/providers/AccessibilityProvider';

interface AppProvidersProps {
  children: ReactNode;
}

export const AppProviders = ({ children }: AppProvidersProps) => {
  return (
    <ErrorBoundary>
      <AccessibilityProvider>
        <NotificationProvider>
          <AuthProvider>
            {children}
            <Toaster
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#363636',
                  color: '#fff',
                },
                success: {
                  duration: 3000,
                  iconTheme: {
                    primary: '#10b981',
                    secondary: '#fff',
                  },
                },
                error: {
                  duration: 5000,
                  iconTheme: {
                    primary: '#ef4444',
                    secondary: '#fff',
                  },
                },
              }}
            />
          </AuthProvider>
        </NotificationProvider>
      </AccessibilityProvider>
    </ErrorBoundary>
  );
};